// extracted by mini-css-extract-plugin
module.exports = {"addCompanyWrp":"addProductToIdea_addCompanyWrp__2wMLG","modalTooltip":"addProductToIdea_modalTooltip__OFMdz","loaderWrp":"addProductToIdea_loaderWrp__2qC4t"};